/* 项目回购通知书信息接口 */

import axios from 'axios';

export default {
  // 项目回购通知书列表
  getRepoNoticeList (search, pageNum = 1, pageSize = 10) {
    const params = {
      pageNum,
      pageSize,
      ...search
    };
    return axios.get(
      '/loanform/blitem/blloanitemreponotice/getRepoNoticeList.ht',
      {
        headers: {
          tokenId: localStorage.getItem('dl_tokenId_bl')
        },
        params
      }
    );
  },

  // 项目回购通知书详情
  getRepoNoticeDetail (noticeId) {
    const params = {
      noticeId
    };
    return axios.get(
      '/loanform/blitem/blloanitemreponotice/getRepoNoticeDetail.ht',
      {
        headers: {
          tokenId: localStorage.getItem('dl_tokenId_bl')
        },
        params
      }
    );
  }
};



// WEBPACK FOOTER //
// ./src/api/personalCenter/repoNotice.js